import { environment } from '../environments/environment';
import { AppType } from '../model/app-type.model';

const isAppAgentOrTravelAgency = (): boolean => environment.app === AppType.Agent || environment.app === AppType.TravelAgency;

export default isAppAgentOrTravelAgency;
